import { createClient } from 'contentful';
import type { EntryFieldTypes } from 'contentful';

export const contentfulClient = createClient({
  space: import.meta.env.VITE_CONTENTFUL_SPACE_ID,
  accessToken: import.meta.env.VITE_CONTENTFUL_ACCESS_TOKEN,
});

export interface BlogPostSkeleton {
  contentTypeId: 'blogPost';
  fields: {
    title: EntryFieldTypes.Text;
    slug: EntryFieldTypes.Text;
    excerpt: EntryFieldTypes.Text;
    body: EntryFieldTypes.RichText;
    category: EntryFieldTypes.Text;
    coverImage: EntryFieldTypes.AssetLink;
    publishDate: EntryFieldTypes.Date;
    readTime: EntryFieldTypes.Text;
  };
}

export async function getBlogPosts() {
  const entries = await contentfulClient.getEntries<BlogPostSkeleton>({
    content_type: 'blogPost',
    order: ['-fields.publishDate'],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'fields.publishDate[lte]': new Date().toISOString() as any,
  });
  return entries.items;
}

export async function getBlogPostBySlug(slug: string) {
  const entries = await contentfulClient.getEntries<BlogPostSkeleton>({
    content_type: 'blogPost',
    'fields.slug': slug,
    limit: 1,
  });
  return entries.items[0] ?? null;
}
